import script from "./REGULAR_COMMENT.vue?vue&type=script&lang=ts&setup=true"
export * from "./REGULAR_COMMENT.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__